import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum CharacterLIconVariant {
  ON = 'on',
  OFF = 'off',
}

export interface ICharacterLIconProps extends IConDefaultType {
  variant?: CharacterLIconVariant;
}

function CharacterLIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CharacterLIconVariant.OFF,
}: ICharacterLIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CharacterLIconVariant.OFF && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="#8A8A8A" />
          <path d="M16.3857 18V15.5742H11.5781V6.00293H8.66895V18H16.3857Z" fill="white" />
        </svg>
      )}
      {variant === CharacterLIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="#00C3DD" />
          <path d="M16.3857 18V15.5742H11.5781V6.00293H8.66895V18H16.3857Z" fill="white" />
        </svg>
      )}
    </i>
  );
}

export default CharacterLIcon;
